import LegalLayout from "./LegalLayout";

export default function RefundPolicyHr() {
  return (
    <LegalLayout
      testId="refund-policy-hr-page"
      eyebrow="Pravno"
      title="Pravilnik o otkazivanju i povratu novca"
      updated="Veljača 2026."
    >
      <section>
        <h2>1. Pregled</h2>
        <p>
          Razumijemo da se planovi putovanja mijenjaju. Naš pravilnik o otkazivanju osmišljen je
          tako da bude pošten prema našim klijentima, uz pokriće stvarnih operativnih troškova
          dodjeljivanja vozila, planiranja profesionalnog vozača i unaprijed nabavljenih dodataka
          za vaš prijevoz.
        </p>
      </section>

      <section>
        <h2>2. Rokovi za otkazivanje</h2>
        <ul>
          <li>
            <strong>Više od 24 sata prije planiranog vremena preuzimanja:</strong> depozit se
            vraća u cijelosti. Povrati se obrađuju unutar 5–10 radnih dana na izvornu metodu
            plaćanja.
          </li>
          <li>
            <strong>Unutar 24 sata od planiranog vremena preuzimanja:</strong> rezervacija je
            <strong> neopoziva</strong>. Ovo pokriva operativne troškove, dodjeljivanje vozila,
            angažman vozača i sve unaprijed nabavljene dodatke poput grickalica, pića i 5G SIM
            kartica.
          </li>
          <li>
            <strong>Nedolazak</strong> (klijent se ne pojavi na mjestu preuzimanja i ne odgovori
            na kontakt vozača unutar besplatnog razdoblja čekanja) tretira se kao otkaz istog
            dana i ne podliježe povratu.
          </li>
        </ul>
      </section>

      <section>
        <h2>3. Kako otkazati</h2>
        <p>
          Za otkazivanje rezervacije odgovorite na izvornu potvrdu rezervacije na{" "}
          <a href="mailto:bookings@juketransfers.hr" className="text-[#C5A059] hover:text-[#D4AF37] underline underline-offset-2">bookings@juketransfers.hr</a>
          {" "}ili nam pošaljite poruku na WhatsApp na{" "}
          <a href="https://wa.me/385989344079" className="text-[#C5A059] hover:text-[#D4AF37] underline underline-offset-2">+385 98 934 4079</a>
          {" "}s vašim brojem reference. Trenutak otkazivanja je trenutak primitka vaše pisane
          poruke.
        </p>
      </section>

      <section>
        <h2>4. Promjene rezervacije</h2>
        <p>
          Rado ćemo promijeniti termin vašeg prijevoza na drugi datum ili vrijeme, ovisno o
          dostupnosti. Ako je zahtjev za promjenu upućen više od 24 sata prije preuzimanja, nema
          naknade. Promjene unutar 24 sata mogu podlijegati naknadi za ponovno dispečiranje po
          našoj procjeni.
        </p>
      </section>

      <section>
        <h2>5. Otkazivanja s naše strane</h2>
        <p>
          Ako ne možemo ispuniti vašu rezervaciju zbog okolnosti na našoj strani (kvar vozila
          bez prikladne zamjene, neizbježna nedostupnost vozača), primit ćete <strong>puni
          povrat novca</strong> i, kad je to moguće, organizirat ćemo istovrijedno partnersko
          vozilo bez dodatnih troškova.
        </p>
      </section>

      <section>
        <h2>6. Viša sila</h2>
        <p>
          U slučaju događaja izvan naše razumne kontrole — ekstremni vremenski uvjeti,
          zatvaranje cesta, državna ograničenja, štrajkovi ili zatvaranje zračne luke — hitno
          ćemo vas kontaktirati radi promjene termina ili povrata na temelju svakog pojedinačnog
          slučaja. U takvim okolnostima klijentu se ne naplaćuju nikakve kazne.
        </p>
      </section>

      <section>
        <h2>7. Dodaci i unaprijed nabavljeni artikli</h2>
        <p>
          Dodaci poput rashlađenih pića, kutija s grickalicama i turističkih 5G SIM kartica
          nabavljaju se i pripremaju unaprijed za vašu specifičnu rezervaciju. Nakon što
          rezervacija uđe u neopozivi period od 24 sata, ovi se artikli ne mogu vratiti neovisno
          o naknadi za prijevoz.
        </p>
      </section>

      <section>
        <h2>8. Kontakt</h2>
        <p>
          Za sva pitanja ili sporove oko povrata, obratite nam se na{" "}
          <a href="mailto:bookings@juketransfers.hr" className="text-[#C5A059] hover:text-[#D4AF37] underline underline-offset-2">bookings@juketransfers.hr</a>.
          Nastojimo odgovoriti unutar 24 sata.
        </p>
      </section>
    </LegalLayout>
  );
}
